<script setup>
    import { ref, computed, onMounted, getCurrentInstance, watch, nextTick } from 'vue'
    import { useRouter } from 'vue-router'
    import { useUserStore } from "../../stores/user";
    import { usePageLoadingStore } from "../../../../stores/pageLoading";
    import SNB from '../../../../layouts/nav/SNB.vue'
    import mypageUserService from "../../services/mypage/mypageUserService";
    import _ from 'lodash'
    import signupService from "../../services/signup/signupService";
    import KSAInput from "@/components/ui-components/input/KSAInput.vue";
    import KSAPrimaryButton from "@/components/ui-components/button/KSAPrimaryButton.vue";
    import fileService from "@/services/fileService";
    import moment from "moment";

    const router = useRouter()
    const userStore = useUserStore()
    const loadingStore = usePageLoadingStore()

    const globals = getCurrentInstance().appContext.config.globalProperties;
    const { $toast, $regex, $userGbKR, $gb : { SCHOOL_GB, EDU_TENURE_GB } } = globals;
    const { isAdmin } = userStore;

    onMounted(()=>{
        const { userLoginId } = userStore.user;
        if(userLoginId) {
            input.value.userLoginId = userLoginId;
        }

        _.each(data_interests.value, el => {el.on = false;})
        _.each(data_desiredJob.value, el => {el.on = false;})
    })

    const isAuthenticated = ref(false);
    const isPhoneAuthenticated = ref(false);

    const input = ref({
        userLoginId: '',
        password: '',
        authCode: '',
        // corporationNum1: '', // 법인등록번호(앞자리)
        // corporationNum2: '', // 법인등록번호(뒷자리)
        // ownerName: '', // 대표명
        // anniversary: '', // 창립일
        // scale: 30, // 인원
        // groups: [], // 산업군
    })

    const inputError = ref({
        userLoginId: '',
        password: '',
        authCode: '',
        // corporationNum1: '', // 법인등록번호(앞자리)
        // corporationNum2: '', // 법인등록번호(뒷자리)
        bizNum: "", // 사업자등록번호
        corpName: "", // 기업명
        ceoName: "", // 대표자명
        residenceArea: "", // 사업장소재지
        bizType: "", // 업종
        industryGb: "", // 산업군
        corpGb: "", // 기업형태
        foundYm: "", // 창립연월
        employeeNumGb: "", // 사원수
        salesAmtGb: "", // 매출액
        corpPublicYn: "", // 상장여부
        corpPublicGb: "", // 상장구분
        ciImg: "", // 로고이미지(CI)
        bizLicense: "", // 사업자등록증
    })

    const user = ref({});

    const isEditPhoneNum = ref(false);
    let phoneVerifyId;


    const userNameRef = ref(null);
    const birthYmdRef = ref(null);
    const schoolRef = ref(null);
    const verifyCheckInputRef = ref(null);
    const formEmailRef = ref(null);
    const schoolGbRef =  ref(null);
    const eduTenureGbRef = ref(null);
    const residenceAreaRef = ref(null);
    const residenceAreaCorpRef = ref(null);
    const phoneNumInput = ref(null)
    const companyNumRef = ref(null)
    const corpNum1Ref = ref(null)
    const corpNum2Ref = ref(null)

    const data_interests = ref(globals.$interests)
    const data_desiredJob = ref(globals.$desiredJob)

    const isSchoolSelectDisabled = ref(false);

    //거주 지역
    const onSelectedArea1Option = (option) => {
        user.value.residenceArea1 = option;
    }

    const onSelectedArea2Option = (option) => {
        user.value.residenceArea2 = option;
    }

    // 사업장소재지
    const onSelectedCorpArea1Option = (option) => {
      const { corporation } = user.value;
      corporation.residenceArea1 = option;
    }
    const onSelectedCorpArea2Option = (option) => {
      const { corporation } = user.value;
      corporation.residenceArea2 = option;
    }

    // 상장여부 초기화
    const resetCorpPublic = (val) => {
      const { corporation } = user.value;
      if (val === 'N') {
        corporation.corpPublicGb = ''
        corporation.corpPublicText = ''
      }
    }

    // 상장 기타 초기화
    const resetCorpPublicText = (val) => {
      const { corporation } = user.value;
      if (val === '05') {
        corporation.corpPublicText = ''
      }
    }

    // 산업군 기타 초기화
    const resetIndustryText = (val) => {
      const { corporation } = user.value;
      if (val === '06') {
        corporation.industryText = ''
      }
    }

    // 기업형태 기타 초기화
    const resetCorpText = (val) => {
      const { corporation } = user.value;
      if (val === '05') {
        corporation.corpText = ''
      }
    }


    // 로고이미지(CI) 업로드
    const uploadFileCiImg = (user) => {
      const input = document.createElement('input');
      input.type= 'file';
      input.click();

      input.addEventListener('change', function(event){
        // console.log(event.target.files);
        const file = event.target.files[0];

        let paramObj = {
          container: 'public',
          folder: 'ciImg',
          file,
        }
        fileService.uploadFile(paramObj)
            .then((res) => {
              // console.log(res);
              if(res.data.code.toLowerCase() === 'success') {
                const result = res.data.result;
                // console.log(result);
                user.corporation.ciImgName = result.originalFilename;
                user.corporation.ciImgSize = result.fileSize;
                user.corporation.ciImgDir = result.blobUrl;
              }
            }).catch( (error) =>  {
          console.log(error);
        });
      });
    }

    // 로고이미지(CI) 삭제
    const removeFileCiImg = (user) => {
      user.corporation.ciImgName = '';
      user.corporation.ciImgSize = '';
      user.corporation.ciImgDir = '';
      inputError.value.ciImg = '';
    }

    // 사업자등록증 업로드
    const uploadFileBizLicense = (user) => {
      const input = document.createElement('input');
      input.type= 'file';
      input.click();

      input.addEventListener('change', function(event){
        // console.log(event.target.files);
        const file = event.target.files[0];

        let paramObj = {
          container: 'private',
          folder: 'bizLicense',
          file,
        }
        fileService.uploadFile(paramObj)
            .then((res) => {
              // console.log(res);
              if(res.data.code.toLowerCase() === 'success') {
                const result = res.data.result;
                // console.log(result);
                user.corporation.bizLicenseName = result.originalFilename;
                user.corporation.bizLicenseSize = result.fileSize;
                user.corporation.bizLicenseDir = result.blobUrl;
              }
            }).catch( (error) =>  {
          console.log(error);
        });
      });
    }

    // 사업자등록증 삭제
    const removeFileBizLicense = (user) => {
      user.corporation.bizLicenseName = '';
      user.corporation.bizLicenseSize = '';
      user.corporation.bizLicenseDir = '';
      inputError.value.bizLicense = '';
    }

    // 기업소개서 업로드
    const uploadFileCorpIntro = (user) => {
      const input = document.createElement('input');
      input.type= 'file';
      input.click();

      input.addEventListener('change', function(event){
        // console.log(event.target.files);
        const file = event.target.files[0];

        let paramObj = {
          container: 'private',
          folder: 'corpIntro',
          file,
        }
        fileService.uploadFile(paramObj)
            .then((res) => {
              // console.log(res);
              if(res.data.code.toLowerCase() === 'success') {
                const result = res.data.result;
                // console.log(result);
                user.corporation.corpIntroName = result.originalFilename;
                user.corporation.corpIntroSize = result.fileSize;
                user.corporation.corpIntroDir = result.blobUrl;
              }
            }).catch( (error) =>  {
          console.log(error);
        });
      });
    }

    // 기업소개서 삭제
    const removeFileCorpIntro = (user) => {
      user.corporation.corpIntroName = '';
      user.corporation.corpIntroSize = '';
      user.corporation.corpIntroDir = '';
    }

    const submit = () => {
    }


    const modal = ref(null)
    const modalContent = ref([]);

    const auth = () => {
        const { password } = input.value;
        let isInvalid = false;

        inputError.value.password = ''
        if(!password) {
            inputError.value.password = '비밀번호를 입력해주세요.';
            isInvalid = true;
        }

        if(!isInvalid) {
            loadingStore.loading = true;
            mypageUserService.checkPassword(password)
                .then( async (res) => {
                    loadingStore.loading = false;
                    if(res.data.code.toLowerCase() === 'success') {
                        const result = res.data.result;
                        // console.log(result);
                        isAuthenticated.value = true;
                        retrieveUserInfo();
                    } else {
                        modalContent.value = ["비밀번호가 올바르지 않습니다."];
                        modal.value.show();
                    }
                }).catch( (res) =>  {
                loadingStore.loading = false;
                // console.log(res);
                modalContent.value = [res.response.data.result.message];
                modal.value.show();
            });
        }
    }

    // 고졸(05)일 경우, 학교(대학) & 상태 필수표시(*) 제거.
    const schoolInputClass = computed(() => {
      return user.value.schoolGb === '05' ? '' : 'mark';
    });

    // 고졸(05)일 경우, 학교(대학) & 상태 비활성화.
    watch( () => user.value.schoolGb, async (newValue) => {
      await nextTick();
      if( newValue === '05') {
        isSchoolSelectDisabled.value = true;
        user.value.school = '고졸';
        eduTenureGbRef.value.initSelectedOption('01');
        user.value.eduTenureGb = '01'
      } else {
        isSchoolSelectDisabled.value = false;
        user.value.school = '';
        //eduTenureGbRef.value?.initSelectedData();
        //user.value.eduTenureGb = ''
      }
    });

    // 페이지 띄울 때, 학교 세팅 안 되어서 추가.
    watch(() => user.value.school, async (newValue) => {
          if (newValue) {
            try {
              await nextTick(); // DOM이 업데이트된 후에 접근

              if (schoolRef?.value) {
                schoolRef.value.setValue(newValue); // 컴포넌트에 직접 값 설정
              } else {
                console.warn('schoolRef is not ready.');
              }
            } catch (error) {
              console.error('Error setting school value:', error);
            }
          }
        }
    );

    const retrieveUserInfo = () => {
        loadingStore.loading = true;
        mypageUserService.retrieveUserInfo()
            .then( async (res) => {
                loadingStore.loading = false;
                if(res.data.code.toLowerCase() === 'success') {
                    await nextTick();

                    const result = res.data.result;
                    // console.log(result);

                    const { userGb, phoneNum, email, schoolGb, eduTenureGb, residenceArea1, residenceArea2, corporation } = result;

                    result.userGbName = $userGbKR(userGb);

                    if(phoneNum) {
                        result.phoneNum = phoneNum.substring(0,3) + '-' + phoneNum.substring(3,7) + '-' + phoneNum.substring(7);
                    }

                    if(email) {
                        const emailTemp = email.split('@');
                        // console.log(emailTemp)
                        result.email1 = emailTemp[0];
                        result.email2 = emailTemp[1];
                        setTimeout(()=>{
                            formEmailRef.value.init(result.email1, result.email2);
                        },500)
                    }

                    if(result.interests !== null && result.interests !== '') {
                        _.each(data_interests.value, el => {
                            el.on = result.interests.indexOf(el.label) > -1;
                        })
                    }

                    if(result.desiredJob !== null && result.desiredJob !== '') {
                        _.each(data_desiredJob.value, el => {
                            el.on = result.desiredJob.indexOf(el.label) > -1;
                        })
                    }

                    if(result.ableClass !== null && result.ableClass !== '') {
                        _.each(data_interests.value, el => {
                            el.on = result.ableClass.indexOf(el.label) > -1;
                        })
                    }

                    if(result.expertField !== null && result.expertField !== '') {
                        _.each(data_desiredJob.value, el => {
                            el.on = result.expertField.indexOf(el.label) > -1;
                        })
                    }

                    if(schoolGb) {
                        setTimeout(()=>{
                            schoolGbRef.value?.initSelectedOption(schoolGb);
                        },500)
                    }
                    if(eduTenureGb) {
                        setTimeout(()=>{
                            eduTenureGbRef.value?.initSelectedOption(eduTenureGb);
                        },500)
                    }
                    if(residenceArea1 || residenceArea2) {
                        setTimeout(()=>{
                            residenceAreaRef.value.initSelectedOption(residenceArea1, residenceArea2)
                        },500)
                    }

                    if(corporation !== null ) {
                        const { bizNum, corpNum, foundYm, residenceArea1, residenceArea2 } = corporation;
                        if(bizNum) {
                            result.corporation.bizNum = bizNum.substring(0,3) + '-' + bizNum.substring(3,5) + '-' + bizNum.substring(5);
                        }
                        if(corpNum) {
                            result.corporation.corpNum1 = corpNum.substring(0,6);
                            result.corporation.corpNum2 = corpNum.substring(6);
                        }
                        if(foundYm) {
                          result.corporation.foundYm = foundYm.substring(0,4) + '.' + foundYm.substring(4,6);
                        }
                      if(residenceArea1 || residenceArea2) {
                        setTimeout(()=>{
                          residenceAreaCorpRef.value.initSelectedOption(residenceArea1, residenceArea2)
                        },500)
                      }
                    }

                    user.value = result;
                }
            }).catch( (error) =>  {
            loadingStore.loading = false;
            console.log(error);
        });
    }

    // 이름에 한글,영어대문자만 포함되어 있는지 validation.
    const verifyUserName = (userName) => {
      const regex = /^[가-힣A-Z]+$/;
      return regex.test(userName);
    }

    // 핸드폰 번호 변경 위해 인증번호 발송 시, validation
    const sendAuthCode = () => {
        const name = user.value.userName;

        let isInvalid = false;

        inputError.value.name = '';
        inputError.value.phoneNum = '';

        if(!name || !verifyUserName(name)) {
            inputError.value.userName = '주민등록상의 실명(한글 본명)을 입력해 주세요.';
            isInvalid = true;
        }

        const phoneNum = phoneNumInput.value.getValue();
        user.value.phoneNum = phoneNum;
        if(!phoneNum) {
            inputError.value.phoneNum = '핸드폰 번호를 입력하세요';
            isInvalid = true;
        } else if(phoneNum.length !== 13 || !$regex.phoneNum.test(phoneNum)){ // 영문/국문 입력시, 11자리 아닌경우
            inputError.value.phoneNum = '핸드폰 번호를 올바르게 입력하세요';
            isInvalid = true;
        }

        if(!isInvalid) {
            user.value.authCode = '';
            inputError.value.authCode = '';

            loadingStore.loading = true;
            signupService.phoneVerify({ verifyGubun: "changenum", name, phoneNum })
                .then( (res) => {
                    loadingStore.loading = false;
                    if(res.data.code.toLowerCase() === 'success') {
                        const result = res.data.result;
                        // console.log(result);
                        phoneVerifyId = result.phoneVerifyId;
                        verifyCheckInputRef.value.startTimer()

                        modalContent.value = ["인증번호를 전송하였습니다."];
                        modal.value.show();
                    }
                }).catch( (error) =>  {
                loadingStore.loading = false;
                console.log(error);
            });
        }
    }

    const verifyCheck = () => {
        const { phoneNum, authCode } = user.value;

        let isInvalid = false;

        inputError.value.authCode = '';
        if(!authCode || authCode.length !== 6) {
            inputError.value.authCode = '인증번호 6자리를 입력해주세요.';
            isInvalid = true;
        }

        if(!isInvalid) {
            let paramObj = {
                verifyGubun: "changenum",
                phoneVerifyId,
                phoneNum,
                verifyNum: authCode
            }

            loadingStore.loading = true;
            signupService.phoneVerifyCheck(paramObj)
                .then( (res) => {
                    loadingStore.loading = false;
                    const { code, msg } = res.data;
                    if(code.toLowerCase() === 'success') {
                        const result = res.data.result;
                        inputError.value.authCode = '인증번호를 확인하였습니다.';
                        isPhoneAuthenticated.value = true;
                        verifyCheckInputRef.value.clearTimer()
                        isEditPhoneNum.value = false;

                        modalContent.value = ["인증번호를 확인하였습니다."];
                        modal.value.show();

                    } else { // fail
                        if(msg.indexOf('PhoneVerify Number different') > -1) {
                            inputError.value.authCode = '인증번호가 올바르지 않습니다.'; // msg;
                        } else if(msg.indexOf('PhoneVerify 시간초과~') > -1) {
                            inputError.value.authCode = '인증번호 입력 시간이 모두 지났습니다. 인증번호를 다시 전송하세요'; // msg;
                        } else if (msg.indexOf('Not Found User') > -1) {
                            modalContent.value = [
                                "입력한 정보와 일치하는 회원정보가 없습니다.",
                                "다시 입력하여 시도하거나 회원가입을 해주세요"
                            ];
                            modal.value.show();

                            user.value.authCode = '';
                            verifyCheckInputRef.value.clearTimer()
                        }
                        isPhoneAuthenticated.value = false;
                    }
                }).catch( (error) =>  {
                loadingStore.loading = false;
                console.log(error);
            });
        }
    }

    const onUpdateErrorMsg = (value) => {
        inputError.value.authCode = value;
    }

    const onUpdateCorp = (corp) => {
        user.value.corporation.corpId = corp.corpId;
        user.value.corporation.corpName = corp.corpName;

        inputError.value.corpName = '';
        if(corp.corpId === 0) {
            inputError.value.corpName = '사업자등록번호가 올바르지 않습니다. 다시 입력하세요.';
        }
    }


    const save = () => {
        let isInvalid = false;
        let focused = false;
        const _user = _.cloneDeep(user.value);
        const { corporation } = _user;

        inputError.value = {};
        if(!_user.userName || !verifyUserName(_user.userName)) {
            inputError.value.userName = `${_user.userGb === 'SCHOOL' ? '담당자 ' : ''}주민등록상의 실명(한글 본명)을 입력해 주세요.`;
            isInvalid = true;
            if(!focused) {
                userNameRef.value.focus();
                focused = true;
            }
        }
        if(!_user.phoneNum) {
            inputError.value.phoneNum = '핸드폰 번호를 입력하세요.';
            isInvalid = true;
            if(!focused) {
                phoneNumInput.value.focus();
                focused = true;
            }
        }
        if(!_user.email1 || !_user.email2) {
            inputError.value.email = '이메일을 입력하세요.';
            isInvalid = true;
            if(!focused) {
                formEmailRef.value.focus(!!_user.email1);
                focused = true;
            }
        }
        if(!_user.birthYmd) {
            inputError.value.birthYmd = '생년월일을 입력하세요.';
            isInvalid = true;
            if(!focused) {
                birthYmdRef.value.focus();
                focused = true;
            }
        } else if(_user.birthYmd.length !== 8) {
            inputError.value.birthYmd = '생년월일을 YYYYMMDD 형식으로 입력하세요.';
            isInvalid = true;
            if(!focused) {
                birthYmdRef.value.focus();
                focused = true;
            }
        }
        if((_user.residenceArea1 === '' || _user.residenceArea1 === '시/도 선택') ||
            (_user.residenceArea2 === '' || _user.residenceArea2 === '시/구/군 선택') ) {
            inputError.value.residenceArea = (_user.residenceArea1 === '' || _user.residenceArea1 === '시/도 선택') ? '시/도를 선택하세요.' : '시/구/군을 선택하세요.';
            isInvalid = true;
        }

        if(_user.userGb === 'STUDENT' || _user.userGb === 'SCHOOL') { // 학교, 학력
            if(!_user.schoolGb) {
                inputError.value.schoolGb = '학력을 선택하세요.';
                isInvalid = true;
            }
            if(_user.schoolGb !== '05' && !_user.school) {
                inputError.value.school = '학교를 입력하세요.';
                isInvalid = true;
                if(!focused) {
                    schoolRef.value.focus();
                    focused = true;
                }
            }
            if(_user.schoolGb !== '05' && !_user.eduTenureGb) {
                inputError.value.eduTenureGb = '상태를 선택하세요.';
                isInvalid = true;
            }
        } else if(_user.userGb === 'COMPANY' && user.value.corpMasterYn === 'Y') { // 재직자/기업 - 마스터
            if(!_user.corporation.bizNum || _user.corporation.bizNum.length !== 12) {
                inputError.value.companyNum = !_user.corporation.bizNum ? '사업자등록번호를 입력하세요.' : '10자리 숫자를 입력하세요.';
                isInvalid = true;
                if(!focused) {
                    companyNumRef.value.focus();
                    focused = true;
                }
            }

            if(!_user.corporation.corpName) {
                inputError.value.corpName = '기업명을 입력하세요.';
                isInvalid = true;
            }

            if(!_user.corporation.ceoName) {
              inputError.value.ceoName = '대표자명을 입력하세요.';
              isInvalid = true;
            }

            if((_user.corporation.residenceArea1 === '' || _user.corporation.residenceArea1 === '시/도 선택') ||
                (_user.corporation.residenceArea2 === '' || _user.corporation.residenceArea2 === '시/구/군 선택') ) {
              inputError.value.residenceArea = (_user.corporation.residenceArea1 === '' || _user.corporation.residenceArea1 === '시/도 선택') ? '시/도를 선택하세요.' : '시/구/군을 선택하세요.';
              isInvalid = true;
            }

            if(!_user.corporation.bizType) {
              inputError.value.bizType = '업종을 입력하세요.';
              isInvalid = true;
            }

            if(!_user.corporation.industryGb) {
              inputError.value.industryGb = '산업군을 선택하세요.';
              isInvalid = true;
            } else if(_user.corporation.industryGb === '06' && !_user.corporation.industryText) {
              inputError.value.industryGb = '기타 산업군을 입력하세요.';
              isInvalid = true;
            }

            if(!_user.corporation.corpGb) {
              inputError.value.corpGb = '기업형태를 선택하세요.';
              isInvalid = true;
            } else if(_user.corporation.corpGb === '05' && !_user.corporation.corpText) {
              inputError.value.corpGb = '기타 기업형태를 입력하세요.';
              isInvalid = true;
            }

            const foundYm = moment(_user.corporation.foundYm.replace('.', '')).format("YYYYMM")
            if(!foundYm) {
              inputError.value.foundYm = '창립연월을 입력하세요.';
              isInvalid = true;
            } else if (foundYm) {
              if(foundYm.length !== 6) {
                inputError.value.foundYm = '기간을 YYYY.MM 형식으로 입력하세요.';
                isInvalid = true;
              } else if(foundYm === 'Invalid date'  // 존재하지 않은 기간
                  // || Number(nowYm) < Number(startYm)  // 미래 기간
              ) {
                inputError.value.foundYm = '올바른 기간을 입력하세요.';
                isInvalid = true;
              }
            }

            if(!_user.corporation.employeeNumGb || _user.corporation.employeeNumGb === '00') {
              inputError.value.employeeNumGb = '사원수를 선택하세요.';
              isInvalid = true;
            }

            if(!_user.corporation.salesAmtGb || _user.corporation.salesAmtGb === '00') {
              inputError.value.salesAmtGb = '매출액을 선택하세요.';
              isInvalid = true;
            }

            if(!_user.corporation.corpPublicYn) {
              inputError.value.corpPublicYn = '상장여부를 선택하세요.';
              isInvalid = true;
            } else if(_user.corporation.corpPublicYn === 'Y' && !_user.corporation.corpPublicGb) {
              inputError.value.corpPublicGb = '상장여부를 선택하세요.';
              isInvalid = true;
            } else if(_user.corporation.corpPublicYn === 'Y' && _user.corporation.corpPublicGb === '05' && !_user.corporation.corpPublicText) {
              inputError.value.corpPublicGb = '기타 상장을 입력하세요.';
              isInvalid = true;
            }

            if(!_user.corporation.ciImgName || !_user.corporation.ciImgSize || !_user.corporation.ciImgDir) {
              inputError.value.ciImg = '로고이미지 파일을 선택하세요.';
              isInvalid = true;
            }

            if(!_user.corporation.bizLicenseName || !_user.corporation.bizLicenseSize || !_user.corporation.bizLicenseDir) {
              inputError.value.bizLicense = '사업자등록증 파일을 선택하세요.';
              isInvalid = true;
            }

            // if(user.value.corpMasterYn === 'Y') { // 재직자/기업 - 마스터
            //     if(!_user.corporation.corpNum1 || !_user.corporation.corpNum2) {
            //         inputError.value.corpNum = '법인등록번호를 입력하세요.';
            //         isInvalid = true;
            //         if(!focused) {
            //             if(!_user.corporation.corpNum1) {
            //                 corpNum1Ref.value.focus();
            //             } else if(!_user.corporation.corpNum2) {
            //                 corpNum2Ref.value.focus();
            //             }
            //             focused = true;
            //         }
            //     }
            // }
        }
        // console.log(_user);
        // console.log(inputError);

        const interests = _.map(_.filter(data_interests.value, {'on': true}), 'value').join(',');
        const desiredJob = _.map(_.filter(data_desiredJob.value, {'on': true}), 'value').join(',');
        if(_user.userGb === 'STUDENT' || _user.userGb === 'COMPANY'){
            _user.interests = interests;
            _user.desiredJob = desiredJob;
        } else if(_user.userGb === 'TEACHER') {
            _user.ableClass = interests;
            _user.expertField = desiredJob;
        }

        if(!isInvalid) {
            let paramObj = {
                userGb: _user.userGb,
                school: _user.school,
                schoolGb: _user.schoolGb,
                eduTenureGb: _user.eduTenureGb,
                userName: _user.userName,
                phoneNum: _user.phoneNum ? _user.phoneNum.replace('-','').replace('-','') : _user.phoneNum,
                email: `${_user.email1}@${_user.email2}`,
                birthYmd: _user.birthYmd,
                sex: _user.sex,
                corpMasterYn: _user.corpMasterYn,
                residenceArea1: _user.residenceArea1,
                residenceArea2: _user.residenceArea2,
                interests: _user.interests,
                desiredJob: _user.desiredJob,
                professorName: _user.professorName,
                labName: _user.labName,
                ableClass: _user.ableClass,
                expertField: _user.expertField,
                // modifyId: 0
            }
            // console.log(paramObj);

            if(corporation !== null && (corporation.corpId !== undefined && corporation.corpId !== null)) {
                paramObj.corporation = {
                    corpId: corporation.corpId,
                    bizNum: corporation.bizNum ? corporation.bizNum.replace('-','').replace('-','') : corporation.bizNum,
                    corpName: corporation.corpName,
                    ceoName: corporation.ceoName,
                    residenceArea1: corporation.residenceArea1,
                    residenceArea2: corporation.residenceArea2,
                    bizType: corporation.bizType,
                    industryGb: corporation.industryGb,
                    industryText: corporation.industryText,
                    corpGb: corporation.corpGb,
                    corpText: corporation.corpText,
                    foundYm: corporation.foundYm ? corporation.foundYm.replace('.','').replace('.','') : corporation.foundYm,
                    employeeNumGb: corporation.employeeNumGb,
                    salesAmtGb: corporation.salesAmtGb,
                    corpPublicYn: corporation.corpPublicYn,
                    corpPublicGb: corporation.corpPublicGb,
                    corpPublicText: corporation.corpPublicText,
                    homeUrl: corporation.homeUrl,
                    ciImgName: corporation.ciImgName,
                    ciImgSize: corporation.ciImgSize,
                    ciImgDir: corporation.ciImgDir,
                    bizLicenseName: corporation.bizLicenseName,
                    bizLicenseSize: corporation.bizLicenseSize,
                    bizLicenseDir: corporation.bizLicenseDir,
                    corpIntro: corporation.corpIntro,
                    corpHistory: corporation.corpHistory,
                    corpIntroName: corporation.corpIntroName,
                    corpIntroSize: corporation.corpIntroSize,
                    corpIntroDir: corporation.corpIntroDir,
                };
            }

            loadingStore.loading = true;
            mypageUserService.updateUserInfo(paramObj)
                .then( async (res) => {
                    loadingStore.loading = false;
                    if(res.data.code.toLowerCase() === 'success') {
                        const result = res.data.result;
                        // console.log(result);
                        $toast('', '저장하였습니다.');
                        if(userStore.user.userName !== user.value.userName) {
                            userStore.setUserName(user.value.userName);
                        }
                    } else {
                        modalContent.value = ["저장을 실패하였습니다."];
                        modal.value.show();
                    }
                }).catch( (error) =>  {
                loadingStore.loading = false;
                // console.log(error);
                modalContent.value = ["오류가 발생했습니다. 잠시 후 다시 시도해주세요."];
                modal.value.show();
            });
        }
    }

    const cancel = () => {
        isAuthenticated.value = false;
        input.value.password = '';
    }

    const getUserGbName = (userGb) => {
        switch (userGb) {
            case 'STUDENT':
                return '학생/취업준비생';
            case 'COMPANY':
                return '재직자/기업';
            case 'SCHOOL':
                return '대학/연구실';
            case 'TEACHER':
                return '강사/전문가';
            default:
                return '-';
        }
    }



    const onBlurEmail = () => {
        const { email1, email2 } = user.value;
        const email = `${email1}@${email2}`;
        if(!$regex.email.test(email)) {
            inputError.value.email = '올바른 이메일 형식이 아닙니다. 다시 입력해 주세요.';
        } else {
            inputError.value.email = '';
        }
    }

    const onBlurCompNum = () => {
        const { corporation : { bizNum } } = user.value;
        if(!$regex.compNum.test(bizNum)) {
            inputError.value.companyNum = '올바른 사업자등록번호 형식이 아닙니다. 다시 입력해 주세요.';
        } else {
            inputError.value.companyNum = '';
        }
    }

    const onBlurCorpNum = () => {
        const { corporation : { corpNum1, corpNum2 } } = user.value;
        const corpNum = `${corpNum1}-${corpNum2}`;
        if(!$regex.corpNum.test(corpNum)) {
            inputError.value.corpNum = '올바른 법인등록번호 형식이 아닙니다. 다시 입력해 주세요.';
        } else {
            inputError.value.corpNum = '';
        }
    }

    const interestCount = computed(()=>{
        return _.filter(data_interests.value, {'on': true}).length || 0;
    })

    const onClickInterest = (interest) => {
        inputError.value.interests = '';
        if(interest.on) {
            interest.on  = false;
        } else {
            if(interestCount.value < 3) {
                interest.on = true;
            } else {
                inputError.value.interests = '최대 3개까지 선택할 수 있습니다.';
            }
        }
    }

    const desiredJobCount = computed(()=>{
        return _.filter(data_desiredJob.value, {'on': true}).length || 0;
    })

    const onClickDesiredJob = (desiredJob) => {
        inputError.value.desiredJob = '';
        if(desiredJob.on) {
            desiredJob.on  = false;
        } else {
            if(desiredJobCount.value < 3) {
                desiredJob.on = true;
            } else {
                inputError.value.desiredJob = '최대 3개까지 선택할 수 있습니다.';
            }
        }
    }
</script>

<template>
    <div class="container">
        <div class="inner">
            <div class="flex-wrap">
                <SNB class="snb" />
                <div class="content" v-if="!isAuthenticated">
                    <div class="sub-title">
                        <h3>내 정보</h3>
                        <KSATextButton class="btn gray_button" text="회원탈퇴" @click="router.push({name:'MyPageProfileWithdraw'})" />
                    </div>
                    <div class="sign-wrap">
                        <div class="sign-inner">
                            <p class="text text-center">회원님의 정보를 안전하게 보호하기 위해 비밀번호를 입력해주세요</p>
                            <div class="sign-content">
                                <KSAInput class="text-box" v-model="input.userLoginId" label="아이디" placeholder="아이디 입력하세요." disabled />
                                <KSAInput type="password" class="text-box" v-model="input.password" label="비밀번호" placeholder="비밀번호 입력하세요." :msg="inputError.password" max-length="30"/>
                                <KSAPrimaryButton class="full-btn" text="확인" @click="auth" />
                            </div>
                            <ul class="member">
                                <li><RouterLink :to="{name:'MyPageProfilePWReset'}">비밀번호 변경</RouterLink></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="content" v-if="isAuthenticated">
                    <div class="sub-title">
                        <h3>내 정보</h3>
                        <p><span>*표시는 필수 입력사항</span>입니다.</p>
                    </div>
                    <div class="sign-wrap">
                        <div class="sign-inner">
                            <div class="sign-content">
                                <KSAInput label="회원유형" class="text-box" v-model="user.userGbName" :disabled="true" />
                                <KSAInput label="회원코드" class="text-box" v-model="user.userCd" :disabled="true" />
                                <KSAInput label="아이디" class="text-box" v-model="user.userLoginId" placeholder="아이디를 입력해주세요" :disabled="true" />

                                <!-- 학생/취업준비생 -->
                                <template v-if="user.userGb === 'STUDENT'">
                                    <KSAInput ref="userNameRef" label="이름" class="text-box mark" v-model="user.userName" placeholder="주민등록상의 실명(한글 본명)을 입력해 주세요. ex)홍길동" :msg="inputError.userName" max-length="16"/>
                                    <div class="text-box">
                                        <p class="label mark">핸드폰 번호</p>
                                        <div class="grid phone">
                                            <KSAInputPhoneNum ref="phoneNumInput" class="input" v-model="user.phoneNum" label="" :disabled="!isEditPhoneNum"/>
                                            <KSASecondaryButton v-if="!isEditPhoneNum" class="ml-xs" text="핸드폰 번호 변경" @click="isEditPhoneNum = true" />
                                            <KSAPrimaryButton v-if="isEditPhoneNum" class="ml-xs" text="인증번호 보내기" @click="sendAuthCode" />
                                        </div>
                                        <KSAInputVerifyCheck v-if="isEditPhoneNum" class="mt-xs" ref="verifyCheckInputRef" v-model="user.authCode" @update:msg="onUpdateErrorMsg" :msg="inputError.authCode" :msg-color="isPhoneAuthenticated && 'black'"/>
                                        <KSAPrimaryButton v-if="isEditPhoneNum && !isPhoneAuthenticated" class="mt-xs" text="인증번호 확인" @click="verifyCheck" :disabled="user.authCode && user.authCode.length !== 6" />
                                        <div>
                                            <small style="color:#E71414;">{{ inputError.phoneNum }}</small>
                                        </div>
                                   </div>
                                    <div class="text-box">
                                        <p class="label mark">이메일</p>
                                        <KSAFormEmail
                                            ref="formEmailRef"
                                            :email1="user.email1"
                                            :email2="user.email2"
                                            @update:email1="(value)=>{user.email1 = value}"
                                            @update:email2="(value)=>{user.email2 = value}"
                                            @blur="onBlurEmail"
                                        />
                                        <div>
                                            <small style="color:#E71414;">{{ inputError.email }}</small>
                                        </div>
                                    </div>
                                    <KSAInput ref="birthYmdRef" label="생년월일" class="text-box mark" v-model="user.birthYmd" placeholder="YYYYMMDD 8자리 숫자 입력" :msg="inputError.birthYmd" max-length="8"/>
                                    <div class="text-box">
                                        <p class="label">성별</p>
                                        <KSARadioButton class="mr-lg" name="sex" label="남자" v-model="user.sex" value="01" />
                                        <KSARadioButton class="mr-lg" name="sex" label="여자" v-model="user.sex" value="02" />
                                    </div>
                                    <div class="text-box">
                                        <p class="label mark">학력</p>
                                            <KSASelect
                                                ref="schoolGbRef"
                                                class="select"
                                                v-model="user.schoolGb"
                                                :options="$gb.SCHOOL_GB"/>
                                        <div>
                                          <small style="color:#E71414;">{{ inputError.schoolGb }}</small>
                                        </div>
                                    </div>
                                    <KSAInputSchoolSelect
                                        ref="schoolRef"
                                        label="학교"
                                        class=text-box
                                        :class="schoolInputClass"
                                        v-model="user.school"
                                        placeholder="학교를 입력하세요."
                                        :msg="inputError.school"
                                        msg-color="#E71414"
                                        :disabled="isSchoolSelectDisabled"/>
                                    <div class="text-box">
                                        <p class="label" :class="schoolInputClass">상태</p>
                                        <KSASelect
                                            ref="eduTenureGbRef"
                                            class="select"
                                            :options="$gb.EDU_TENURE_GB"
                                            v-model="user.eduTenureGb"
                                            :disabled="isSchoolSelectDisabled"
                                        />
                                        <div>
                                            <small style="color:#E71414;">{{ inputError.eduTenureGb }}</small>
                                        </div>
                                    </div>
                                    <div class="text-box">
                                        <p class="label mark">거주 지역</p>
                                        <KSASelectResidenceArea ref="residenceAreaRef" class="select" @selectOption1="onSelectedArea1Option" @selectOption2="onSelectedArea2Option"/>
                                        <div>
                                            <small style="color:#E71414;">{{ inputError.residenceArea }}</small>
                                        </div>
                                    </div>
                                    <div class="text-box">
                                        <p class="label" :class="{'mark': false}" style="margin: 0">희망 직무 (최대 3개)</p>
                                        <ul class="grid category-wrap">
                                            <li :class="{'active': desiredJob.on}" v-for="desiredJob in data_desiredJob" @click="onClickDesiredJob(desiredJob)">
                                                {{ desiredJob.label }}
                                            </li>
                                        </ul>
                                        <p>
                                            <small style="color:#E71414;">{{ inputError.desiredJob }}</small>
                                        </p>
                                    </div>
                                    <div class="text-box">
                                        <p class="label" style="margin: 0">관심 카테고리 (최대 3개)</p>
                                        <ul class="grid category-wrap">
                                            <li :class="{'active': interest.on}" v-for="interest in data_interests" @click="onClickInterest(interest)">
                                                {{ interest.label }}
                                            </li>
                                        </ul>
                                        <p>
                                            <small style="color:#E71414;">{{ inputError.interests }}</small>
                                        </p>
                                    </div>
                                </template>

                                <!-- 재직자/기업 -->
                                <template v-else-if="user.userGb === 'COMPANY'">
                                    <KSAInput ref="userNameRef" label="이름" class="text-box mark" v-model="user.userName" placeholder="주민등록상의 실명(한글 본명)을 입력해 주세요. ex)홍길동" :msg="inputError.userName" max-length="16"/>
                                    <div class="text-box">
                                        <p class="label mark">핸드폰 번호</p>
                                        <div class="grid phone">
                                            <KSAInputPhoneNum ref="phoneNumInput" class="input" v-model="user.phoneNum" label="" :disabled="!isEditPhoneNum"/>
                                            <KSASecondaryButton v-if="!isEditPhoneNum" class="ml-xs" text="핸드폰 번호 변경" @click="isEditPhoneNum = true" />
                                            <KSAPrimaryButton v-if="isEditPhoneNum" class="ml-xs" text="인증번호 보내기" @click="sendAuthCode" />
                                        </div>
                                        <KSAInputVerifyCheck v-if="isEditPhoneNum" class="mt-xs" ref="verifyCheckInputRef" v-model="user.authCode" @update:msg="onUpdateErrorMsg" :msg="inputError.authCode" :msg-color="isPhoneAuthenticated && 'black'"/>
                                        <KSAPrimaryButton v-if="isEditPhoneNum && !isPhoneAuthenticated" class="mt-xs" text="인증번호 확인" @click="verifyCheck" :disabled="user.authCode && user.authCode.length !== 6" />
                                        <div>
                                            <small style="color:#E71414;">{{ inputError.phoneNum }}</small>
                                        </div>
                                    </div>
                                    <div class="text-box">
                                        <p class="label mark">이메일</p>
                                        <KSAFormEmail
                                            ref="formEmailRef"
                                            :email1="user.email1"
                                            :email2="user.email2"
                                            @update:email1="(value)=>{user.email1 = value}"
                                            @update:email2="(value)=>{user.email2 = value}"
                                            @blur="onBlurEmail"
                                        />
                                        <div>
                                            <small style="color:#E71414;">{{ inputError.email }}</small>
                                        </div>
                                    </div>
                                    <KSAInput ref="birthYmdRef" label="생년월일" class="text-box mark" v-model="user.birthYmd" placeholder="YYYYMMDD 8자리 숫자 입력" :msg="inputError.birthYmd" max-length="8"/>
                                    <div class="text-box">
                                        <p class="label">성별</p>
                                        <KSARadioButton class="mr-lg" name="sex" label="남자" v-model="user.sex" value="01" />
                                        <KSARadioButton class="mr-lg" name="sex" label="여자" v-model="user.sex" value="02" />
                                    </div>
                                    <div class="text-box">
                                        <p class="label mark">거주 지역</p>
                                        <KSASelectResidenceArea ref="residenceAreaRef" class="select" @selectOption1="onSelectedArea1Option" @selectOption2="onSelectedArea2Option"/>
                                        <div>
                                            <small style="color:#E71414;">{{ inputError.residenceArea }}</small>
                                        </div>
                                    </div>

                                    <div class="text-box">
                                        <p class="label" :class="{'mark': false}" style="margin: 0">본인 직무 (최대 3개)</p>
                                        <ul class="grid category-wrap">
                                            <li :class="{'active': desiredJob.on}" v-for="desiredJob in data_desiredJob" @click="onClickDesiredJob(desiredJob)">
                                                {{ desiredJob.label }}
                                            </li>
                                        </ul>
                                        <p>
                                            <small style="color:#E71414;">{{ inputError.desiredJob }}</small>
                                        </p>
                                    </div>
                                    <div class="text-box">
                                        <p class="label" style="margin: 0">관심 카테고리 (최대 3개)</p>
                                        <ul class="grid category-wrap">
                                            <li :class="{'active': interest.on}" v-for="interest in data_interests" @click="onClickInterest(interest)">
                                                {{ interest.label }}
                                            </li>
                                        </ul>
                                        <p>
                                            <small style="color:#E71414;">{{ inputError.interests }}</small>
                                        </p>
                                    </div>
                                    <!-- s : 기업정보 -->
                                    <!-- 마스터만 보이고 수정 가능 / 2025.04 : 기업정보 변경-->
                                    <div v-show="user.corpMasterYn === 'Y'">
                                      <hr />
                                      <h5>기업 정보</h5>
                                      <div class="text-box">
                                        <KSAInput ref="companyNumRef" label="사업자등록번호" class="text-box mark" v-model="user.corporation.bizNum" placeholder="10자리 숫자 입력" />
                                        <div>
                                          <small style="color:#E71414;">{{ inputError.bizNum }}</small>
                                        </div>
                                      </div>
                                      <div class="text-box">
                                        <KSAInput label="기업명" class="text-box mark" v-model="user.corporation.corpName" :msg="inputError.corpName" />
                                        <div>
                                          <small style="color:#E71414;">{{ inputError.corpName }}</small>
                                        </div>
                                      </div>
                                      <div class="text-box">
                                        <KSAInput class="text-box mark" v-model="user.corporation.ceoName" label="대표명" placeholder="대표명을 입력하세요."/>
                                        <div>
                                          <small style="color:#E71414;">{{ inputError.ceoName }}</small>
                                        </div>
                                      </div>
                                      <!--                                    <div class="text-box">-->
                                      <!--                                        <p class="label mark">법인등록번호</p>-->
                                      <!--                                        <div class="grid half">-->
                                      <!--                                            <KSAInput ref="corpNum1Ref" class="input" v-model="user.corporation.corpNum1" @blur="onBlurCorpNum" placeholder="6자리 숫자 입력" max-length="6" :disabled="user.corpMasterYn !== 'Y'"/>-->
                                      <!--                                            <span class="ml-xs mr-xs">-</span>-->
                                      <!--                                            <KSAInput ref="corpNum2Ref" class="input" v-model="user.corporation.corpNum2" @blur="onBlurCorpNum" placeholder="7자리 숫자 입력" max-length="7" :disabled="user.corpMasterYn !== 'Y'"/>-->
                                      <!--                                        </div>-->
                                      <!--                                        <div>-->
                                      <!--                                            <small style="color:#E71414;">{{ inputError.corpNum }}</small>-->
                                      <!--                                        </div>-->
                                      <!--                                    </div>-->
                                      <div class="text-box">
                                        <p class="label mark">사업장소재지</p>
                                        <KSASelectResidenceArea ref="residenceAreaCorpRef" class="select" @selectOption1="onSelectedCorpArea1Option" @selectOption2="onSelectedCorpArea2Option"/>
                                        <div>
                                          <small style="color:#E71414;">{{ inputError.residenceArea }}</small>
                                        </div>
                                      </div>
                                      <div class="text-box">
                                        <KSAInput class="text-box mark" label="업종" v-model="user.corporation.bizType" placeholder="업종을 입력하세요." />
                                        <div>
                                          <small style="color:#E71414;">{{ inputError.bizType }}</small>
                                        </div>
                                      </div>
                                      <div class="text-box">
                                        <p class="label mark">산업군</p>
                                        <template v-for="option in $gb.INDUSTRY_GB">
                                          <KSARadioButton class="check-box mr-md" name="industryGb" :label="option.label" v-model="user.corporation.industryGb" :value="option.value" @change="resetIndustryText(option.value)" />
                                          <div class="etc-box" v-if="option.label === '기타' && user.corporation.industryGb == option.value" >
                                            <KSAInput class="text-box" v-model="user.corporation.industryText" placeholder="기타 산업군을 입력하세요." />
                                          </div>
                                        </template>
                                        <div>
                                          <small style="color:#E71414;">{{ inputError.industryGb }}</small>
                                        </div>
                                      </div>
                                      <div class="text-box">
                                        <p class="label mark">기업형태</p>
                                        <template v-for="option in $gb.CORP_GB">
                                          <KSARadioButton class="check-box mr-sm" name="corpGb" :label="option.label" v-model="user.corporation.corpGb" :value="option.value" @change="resetCorpText(option.value)"/>
                                          <div class="etc-box" v-if="option.label === '기타' && user.corporation.corpGb == option.value" >
                                            <KSAInput class="text-box" v-model="user.corporation.corpText" placeholder="기타 기업형태를 입력하세요." />
                                          </div>
                                        </template>
                                        <div>
                                          <small style="color:#E71414;">{{ inputError.corpGb }}</small>
                                        </div>
                                      </div>
                                      <div class="text-box">
                                        <KSAInputDateYYYYMM class="text-box mark" v-model="user.corporation.foundYm" label="창립연월" placeholder="YYYYMM 6자리 숫자 입력" format="YYYYMM" max-length="5"/>
                                        <div>
                                          <small style="color:#E71414;">{{ inputError.foundYm }}</small>
                                        </div>
                                      </div>
                                      <div class="text-box">
                                        <p class="label mark">사원수</p>
                                        <KSASelect class="select" v-model="user.corporation.employeeNumGb" :options="$gb['EMPLOYEE_NUM_GB']"/>
                                        <div>
                                          <small style="color:#E71414;">{{ inputError.employeeNumGb }}</small>
                                        </div>
                                      </div>
                                      <div class="text-box">
                                        <p class="label mark">매출액</p>
                                        <KSASelect class="select" v-model="user.corporation.salesAmtGb" :options="$gb['SALES_AMT_GB']"/>
                                        <div>
                                          <small style="color:#E71414;">{{ inputError.salesAmtGb }}</small>
                                        </div>
                                      </div>
                                      <div class="text-box">
                                        <p class="label mark">상장여부</p>
                                        <KSARadioButton class="check-box mr-lg" label="상장" v-model="user.corporation.corpPublicYn" value="Y" @change="resetCorpPublic('Y')" />
                                        <KSARadioButton class="check-box mr-lg" label="비상장" v-model="user.corporation.corpPublicYn" value="N" @change="resetCorpPublic('N')" />
                                        <div>
                                          <small style="color:#E71414;">{{ inputError.corpPublicYn }}</small>
                                        </div>
                                      </div>
                                      <div class="text-box" v-if="user.corporation.corpPublicYn === 'Y'">
                                        <template v-for="option in $gb.CORP_PUBLIC_GB">
                                          <KSARadioButton class="check-box mr-sm" name="corpPublicGb" :label="option.label" v-model="user.corporation.corpPublicGb" :value="option.value" @change="resetCorpPublicText(option.value)" />
                                          <div class="etc-box" v-if="option.label === '기타' && user.corporation.corpPublicGb == option.value" >
                                            <KSAInput class="text-box" v-model="user.corporation.corpPublicText" placeholder="기타 상장을 입력하세요." />
                                          </div>
                                        </template>
                                        <div>
                                          <small style="color:#E71414;">{{ inputError.corpPublicGb }}</small>
                                        </div>
                                      </div>
                                      <KSAInput class="text-box" v-model="user.corporation.homeUrl" label="홈페이지 URL" placeholder="홈페이지 URL을 입력하세요." />
                                      <div class="text-box">
                                        <p class="label mark">로고이미지(CI)</p>
                                        <div class="grid file">
                                          <KSAPrimaryButton text="파일 선택" @click="uploadFileCiImg(user)" />
                                          <KSAInput class="input icon" v-model="user.corporation.ciImgName" placeholder="파일 선택(가로 75px X 세로 40px 사이즈 이미지를 권장합니다.)" disabled />
                                          <button class="delete" @click="removeFileCiImg(user)"><i></i></button>
                                        </div>
                                        <small>최대 200MB 까지 첨부 가능</small>
                                        <div>
                                          <small style="color:#E71414;">{{ inputError.ciImg }}</small>
                                        </div>
                                      </div>
                                      <div class="text-box">
                                        <p class="label mark">사업자등록증</p>
                                        <div class="grid file">
                                          <KSAPrimaryButton text="파일 선택" @click="uploadFileBizLicense(user)" />
                                          <KSAInput class="input icon" v-model="user.corporation.bizLicenseName" placeholder="파일 선택" disabled />
                                          <button class="delete" @click="removeFileBizLicense(user)"><i></i></button>
                                        </div>
                                        <small>최대 200MB 까지 첨부 가능</small>
                                        <div>
                                          <small style="color:#E71414;">{{ inputError.bizLicense }}</small>
                                        </div>
                                      </div>
                                      <div class="text-box">
                                        <p class="label">기업 소개</p>
                                        <KSACKEditor ref="editorRef" v-model="user.corporation.corpIntro" />
                                      </div>
                                      <div class="text-box">
                                        <p class="label">주요 연혁</p>
                                        <KSACKEditor ref="editorRef" v-model="user.corporation.corpHistory" />
                                      </div>
                                      <div class="text-box">
                                        <p class="label">기업 소개서</p>
                                        <div class="grid file">
                                          <KSAPrimaryButton text="파일 선택" @click="uploadFileCorpIntro(user)" />
                                          <KSAInput class="input icon" v-model="user.corporation.corpIntroName" placeholder="파일 선택" disabled />
                                          <button class="delete" @click="removeFileCorpIntro(user)"><i></i></button>
                                        </div>
                                        <small>최대 200MB 까지 첨부 가능</small>
                                      </div>
                                    </div>
                                    <!-- e : 기업정보 -->
                                </template>

                                <!-- 대학/연구실 -->
                                <template v-if="user.userGb === 'SCHOOL'">
                                    <div class="text-box">
                                        <p class="label mark">학력</p>
                                        <KSASelect
                                            ref="schoolGbRef"
                                            class="select"
                                            v-model="user.schoolGb"
                                            :options="$gb.SCHOOL_GB"/>
                                        <div>
                                            <small style="color:#E71414;">{{ inputError.schoolGb }}</small>
                                        </div>
                                    </div>
                                    <KSAInputSchoolSelect
                                        ref="schoolRef"
                                        label="학교"
                                        class=text-box
                                        :class="schoolInputClass"
                                        v-model="user.school"
                                        placeholder="학교를 입력하세요."
                                        :msg="inputError.school"
                                        msg-color="#E71414"
                                        :disabled="isSchoolSelectDisabled"/>
                                    <div class="text-box">
                                        <p class="label" :class="schoolInputClass">상태</p>
                                        <KSASelect
                                            ref="eduTenureGbRef"
                                            class="select"
                                            :options="$gb.EDU_TENURE_GB"
                                            v-model="user.eduTenureGb"
                                            :disabled="isSchoolSelectDisabled"
                                        />
                                        <div>
                                            <small style="color:#E71414;">{{ inputError.eduTenureGb }}</small>
                                        </div>
                                    </div>
                                    <KSAInput ref="userNameRef" label="담당자 이름" class="text-box mark" v-model="user.userName" placeholder="주민등록상의 실명(한글 본명)을 입력해 주세요. ex)홍길동"  :msg="inputError.userName" max-length="16"/>
                                    <div class="text-box">
                                        <p class="label mark">핸드폰 번호</p>
                                        <div class="grid phone">
                                            <KSAInputPhoneNum ref="phoneNumInput" class="input" v-model="user.phoneNum" label="" :disabled="!isEditPhoneNum"/>
                                            <KSASecondaryButton v-if="!isEditPhoneNum" class="ml-xs" text="핸드폰 번호 변경" @click="isEditPhoneNum = true" />
                                            <KSAPrimaryButton v-if="isEditPhoneNum" class="ml-xs" text="인증번호 보내기" @click="sendAuthCode" />
                                        </div>
                                        <KSAInputVerifyCheck v-if="isEditPhoneNum" class="mt-xs" ref="verifyCheckInputRef" v-model="user.authCode" @update:msg="onUpdateErrorMsg" :msg="inputError.authCode" :msg-color="isPhoneAuthenticated && 'black'"/>
                                        <KSAPrimaryButton v-if="isEditPhoneNum && !isPhoneAuthenticated" class="mt-xs" text="인증번호 확인" @click="verifyCheck" :disabled="user.authCode && user.authCode.length !== 6" />
                                        <div>
                                            <small style="color:#E71414;">{{ inputError.phoneNum }}</small>
                                        </div>
                                    </div>
                                    <div class="text-box">
                                        <p class="label mark">이메일</p>
                                        <KSAFormEmail
                                            ref="formEmailRef"
                                            :email1="user.email1"
                                            :email2="user.email2"
                                            @update:email1="(value)=>{user.email1 = value}"
                                            @update:email2="(value)=>{user.email2 = value}"
                                            @blur="onBlurEmail"
                                        />
                                        <div>
                                            <small style="color:#E71414;">{{ inputError.email }}</small>
                                        </div>
                                    </div>
                                    <KSAInput ref="birthYmdRef" label="생년월일" class="text-box mark" v-model="user.birthYmd" placeholder="YYYYMMDD 8자리 숫자 입력" :msg="inputError.birthYmd" max-length="8"/>
                                    <div class="text-box">
                                        <p class="label">성별</p>
                                        <KSARadioButton class="mr-lg" name="sex" label="남자" v-model="user.sex" value="01" />
                                        <KSARadioButton class="mr-lg" name="sex" label="여자" v-model="user.sex" value="02" />
                                    </div>
                                    <div class="text-box">
                                        <p class="label mark">거주 지역</p>
                                        <KSASelectResidenceArea ref="residenceAreaRef" class="select" @selectOption1="onSelectedArea1Option" @selectOption2="onSelectedArea2Option"/>
                                        <div>
                                            <small style="color:#E71414;">{{ inputError.residenceArea }}</small>
                                        </div>
                                    </div>
                                    <KSAInput label="교수님 이름" class="text-box" v-model="user.professorName" placeholder="교수님 이름을 입력하세요." max-length="30" />
                                    <KSAInput label="연구실 이름" class="text-box" v-model="user.labName" placeholder="연구실 이름을 입력하세요." max-length="30" />
                                </template>

                                <!-- 강사/전문가 -->
                                <template v-if="user.userGb === 'TEACHER'">
                                    <KSAInput ref="userNameRef" label="이름" class="text-box mark" v-model="user.userName" placeholder="주민등록상의 실명(한글 본명)을 입력해 주세요. ex)홍길동" :msg="inputError.userName" max-length="16"/>
                                    <div class="text-box">
                                        <p class="label mark">핸드폰 번호</p>
                                        <div class="grid phone">
                                            <KSAInputPhoneNum ref="phoneNumInput" class="input" v-model="user.phoneNum" label="" :disabled="!isEditPhoneNum"/>
                                            <KSASecondaryButton v-if="!isEditPhoneNum" class="ml-xs" text="핸드폰 번호 변경" @click="isEditPhoneNum = true" />
                                            <KSAPrimaryButton v-if="isEditPhoneNum" class="ml-xs" text="인증번호 보내기" @click="sendAuthCode" />
                                        </div>
                                        <KSAInputVerifyCheck v-if="isEditPhoneNum" class="mt-xs" ref="verifyCheckInputRef" v-model="user.authCode" @update:msg="onUpdateErrorMsg" :msg="inputError.authCode" :msg-color="isPhoneAuthenticated && 'black'"/>
                                        <KSAPrimaryButton v-if="isEditPhoneNum && !isPhoneAuthenticated" class="mt-xs" text="인증번호 확인" @click="verifyCheck" :disabled="user.authCode && user.authCode.length !== 6" />
                                        <div>
                                            <small style="color:#E71414;">{{ inputError.phoneNum }}</small>
                                        </div>
                                    </div>
                                    <div class="text-box">
                                        <p class="label mark">이메일</p>
                                        <KSAFormEmail
                                            ref="formEmailRef"
                                            :email1="user.email1"
                                            :email2="user.email2"
                                            @update:email1="(value)=>{user.email1 = value}"
                                            @update:email2="(value)=>{user.email2 = value}"
                                            @blur="onBlurEmail"
                                        />
                                        <div>
                                            <small style="color:#E71414;">{{ inputError.email }}</small>
                                        </div>
                                    </div>
                                    <KSAInput ref="birthYmdRef" label="생년월일" class="text-box mark" v-model="user.birthYmd" placeholder="YYYYMMDD 8자리 숫자 입력" :msg="inputError.birthYmd" max-length="8"/>
                                    <div class="text-box">
                                        <p class="label">성별</p>
                                        <KSARadioButton class="mr-lg" name="sex" label="남자" v-model="user.sex" value="01" />
                                        <KSARadioButton class="mr-lg" name="sex" label="여자" v-model="user.sex" value="02" />
                                    </div>
                                    <div class="text-box">
                                        <p class="label mark">거주 지역</p>
                                        <KSASelectResidenceArea ref="residenceAreaRef" class="select" @selectOption1="onSelectedArea1Option" @selectOption2="onSelectedArea2Option"/>
                                        <div>
                                            <small style="color:#E71414;">{{ inputError.residenceArea }}</small>
                                        </div>
                                    </div>
                                    <div class="text-box">
                                        <p class="label" style="margin: 0">교육 가능 과목 (최대 3개)</p>
                                        <ul class="grid category-wrap">
                                            <li :class="{'active': interest.on}" v-for="interest in data_interests" @click="onClickInterest(interest)">
                                                {{ interest.label }}
                                            </li>
                                        </ul>
                                        <p>
                                            <small style="color:#E71414;">{{ inputError.interests }}</small>
                                        </p>
                                    </div>
                                    <div class="text-box">
                                        <p class="label" :class="{'mark': false}" style="margin: 0">전문 분야 (최대 3개)</p>
                                        <ul class="grid category-wrap">
                                            <li :class="{'active': desiredJob.on}" v-for="desiredJob in data_desiredJob" @click="onClickDesiredJob(desiredJob)">
                                                {{ desiredJob.label }}
                                            </li>
                                        </ul>
                                        <p>
                                            <small style="color:#E71414;">{{ inputError.desiredJob }}</small>
                                        </p>
                                    </div>
                                </template>
                            </div>
                            <div :class="{'btn-wrap': !isAdmin}">
                                <KSASecondaryButton class="full-btn" text="취소" @click="cancel" />
                                <KSAPrimaryButton v-if="!isAdmin" class="full-btn" text="저장" @click="save" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <AlertModal ref="modal" :content="modalContent" />
</template>

<style lang="scss" scoped>
    @import "../../../../assets/scss/theme";

    .sign-wrap {
        padding: 0;
    }

    .sub-title {
        justify-content: space-between;
        .btn {
            margin-bottom: -10px;
        }

    }

    .check-box {
        &:last-child {
            margin-right: 0 !important;
        }
    }

    hr {
        height: 1px;
        border: 0;
        background-color: $gray-light_color;
        margin: 40px 0;
    }

    h5 {
        color: $gray_color;
        @include font-size_lg;
        margin-bottom: -10px;
    }
</style>